import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Container = styled('div')(({ theme }) => ({
  height: '100%',

  '& .MuiDataGrid-columnHeaders': {
    background: 'rgba(241, 238, 243, 1)',
    border: '1px solid rgba(223, 228, 242, 1)',
    minHeight: '32px !important',
    fontFamily: 'Poppins'
  },

  '& .MuiDataGrid-pinnedColumnHeaders': {
    backgroundColor: '#f1eef3'
  },

  '& .MuiDataGrid-columnHeader': {
    height: '32px !important'
  },

  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 600,
    fontSize: '12px',
    color: '#6B7280'
  },

  '& .MuiDataGrid-row': {
    backgroundColor: '#FFFFFF',
    '&:hover': {
      cursor: 'pointer'
    }
  },

  '& .Mui-selected': {
    backgroundColor: '#F9FAFB !important'
  },

  '& .MuiDataGrid-cell': {
    whiteSpace: 'pre-wrap !important'
  },

  '& .all-loads__status > div': {
    marginBottom: '0px'
  }
}));

export const Footer = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFFFFF'
}));
